import auth from './auth'
import adminRoutes from './admin'
import userRoutes from './user'
import errorRoutes from './errors'

let routeFiles = []
/* Multi Route Files */
const routes = routeFiles.concat(
  auth,
  adminRoutes,
  userRoutes,
  errorRoutes
//   auth,
//   home,
//   users
  /* add here Other Routes File */
)

export default routes
